import BaseController from '../BaseController';
import Controller, { OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { PanelAPI } from '@philips-internal/oswald-ui-components';
import ConfigurationService from '../../services/configuration-service';

@Controller({ component: 'footer-title-layout', fragment: 'footer-title' })
class FooterTitleController extends BaseController {

  private THEME_DARK = '2';

  @Inject('powered-philips-panel')
    poweredPhilipsPanel!: PanelAPI;

  @OnMount({ target: ['footer-title-layout'] })
  onMountFooterLayout(): void {
    ConfigurationService.getConfigurationData().then(layoutData => {
      const gradientColor = 'linear-gradient(279deg, #24528a, #24528a)';
      this.poweredPhilipsPanel.setLightTheme(layoutData.ieFontColor === this.THEME_DARK);
      this.poweredPhilipsPanel.setBackground(gradientColor);
    });
  }
}

export default FooterTitleController;
